import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-instruction-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './instruction-modal.component.html',
  styleUrl: './instruction-modal.component.scss'
})
export class InstructionModalComponent {
  @Input() modalData: { type: string, index: number, title: string, max: number, icon: string } | null = null;
  @Input() assistType: 'medical' | 'travel' = 'medical';
  @Output() close = new EventEmitter<void>();
  @Output() proceed = new EventEmitter<void>();
}